import {
  Component,
  Input,
  AfterViewChecked,
  ElementRef,
  ViewChild
} from '@angular/core';

type Log = {
  theme: 'danger' | 'primary' | 'success';
  heading: string;
  message: string;
};

@Component({
  selector: 'app-terminal-log',
  templateUrl: './terminal-log.component.html',
  standalone:false,
  styleUrls: ['./terminal-log.component.scss']
})
export class TerminalLogComponent implements AfterViewChecked {

  @Input() logs: Log[] = [];

  // 🔥 NEW OPTIONS
  @Input() showHeader: boolean = true;
  @Input() rounded: boolean = true;

  @ViewChild('terminalBody') terminalBody!: ElementRef;

  trackByIndex(index: number) {
    return index;
  }

  getThemeClass(theme: Log['theme']) {
    return {
      'text-danger': theme === 'danger',
      'text-success': theme === 'success',
      'text-primary': theme === 'primary',
    };
  }

  ngAfterViewChecked() {
    if (this.terminalBody) {
      const el = this.terminalBody.nativeElement;
      el.scrollTop = el.scrollHeight;
    }
  }
}